import { MvTherapySystemSetupDto } from '@/api/generator';
import { NotificationMessage } from '@/components/notifications/types';
import { Namespace, TFunction } from 'i18next';

export const checkIfBeamQualitiesAreSelected = (mvTherapySystemSetup: MvTherapySystemSetupDto) => {
  const { isEnabled, beamQualitiesPhoton, beamQualitiesElectron } =
    mvTherapySystemSetup.beamQualityContainer;

  return (
    isEnabled && [...beamQualitiesPhoton, ...beamQualitiesElectron].some((item) => item.isEnabled)
  );
};

export function getNotificationsObj(
  t: TFunction<Namespace, undefined>,
  generate: () => Promise<void>,
): Record<string, NotificationMessage> {
  return {
    parameterInvalid: {
      type: 'error',
      title: t('SetupCombinationsParametersInvalidTitle'),
      message: t('SetupCombinationsParametersInvalid'),
      closable: false,
    },
    parametersChanged: {
      type: 'warning',
      title: t('SetupCombinationsParametersChangedTitle'),
      message: t('SetupCombinationsParametersChangedMessage'),
      actionForNotification: {
        actionTitle: t('SetupCombinationsParametersChangedNotification'),
        action: generate,
      },
      closable: false,
    },
    combinationSelectionChanged: {
      type: 'warning',
      title: t('SetupCombinationsSelectionChangedTitle'),
      message: t('SetupCombinationsSelectionChangedMessage'),
      actionForNotification: {
        actionTitle: t('Confirm'),
        action: generate,
      },
      closable: false,
    },
    beamQualitiesAreMissing: {
      type: 'warning',
      title: t('SetupCombinationsParametersQualitiesMissingTitle'),
      message: t('SetupCombinationsParametersQualitiesMissingMessage'),
      closable: false,
    },
    setupMissing: {
      type: 'info',
      title: t('SetupCombinationsSetupMissingTitle'),
      message: t('SetupCombinationsSetupMissingMessage'),
      closable: false,
    },
    measurementMissing: {
      type: 'warning',
      message: t('ReferenceMeasurementMissing'),
      closable: false,
    },
    measurementOutdated: {
      type: 'warning',
      message: t('ReferenceMeasurementOutdated'),
      closable: false,
    },
    calibrationMissing: {
      type: 'warning',
      message: t('ReferenceMeasurementCalibrationMissing'),
      closable: false,
    },
    qualityMissing: {
      type: 'warning',
      message: t('SetupCombinationsQualityMissingMessage'),
      closable: false,
    },
    emptySetupTableReurned: {
      type: 'info',
      message: 'An empty table was returned 😩.',
      closable: false,
    },
  };
}
